import axiosInstance from "../../../axios";
export const getEnrolledStudentsService = async (pageData) => {
  console.log("enrolled search : ", pageData);
  if (!pageData.studentName) {
    pageData.studentName = ""
  }
  if (pageData?.assessStatus === undefined) {
    pageData.assessStatus = "";
  }
  if (pageData?.courseId?.length < 1) {
    pageData.BatchIdDropdown = "";
  }
  try {
    const response = await axiosInstance.get(`/batch/enroll-students?pageLength=99999&pageNo=1&studentName=${pageData.studentName}&courseId=${pageData.courseId}&batchId=${pageData.BatchIdDropdown}&studentId=${pageData?.studentId}&accessStat=${pageData?.assessStatus}`);
    return response.data;
  } catch (error) {
    // console.error("Error in getCourseTableService:", error);
    throw error;
  }
};
